<div class="container-xxl gx-0 logo-container">
    @if (showLogo && isLoaded) {
        <div class="inner-logo" [ngClass]="{ 'logo-animate': isLoaded }">
            <img class="img-fluid" src="/assets/images/logo-stelmach.svg" alt="Stelmach" />
        </div>
    }
    <img #logo class="img-fluid" [src]="src" alt="Stelmach Banner" />
</div>
